import { INVOICE_STATUS } from '../invoice/invoice_enums.types';
import { Vendor } from 'aws-sdk/clients/directconnect';

export interface IOrderRequestType {
  id?: number;
  orderDate?: Date;
  totalAmount?: number;
  currentTime?: Date;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  updatedBy?: string;
  status?: string;
  restaurantId?: number;
}

export interface IOrderDataResponse {
  id: number;
  orderDate: Date;
  totalAmount: number;
  currentTime: Date;
  createdAt: Date;
  updatedAt: Date;
  createdBy?: string;
  updatedBy?: string;
  status?: string;
  restaurantId: number;
}

export interface IOrderInvoiceResponse {
  recordType: 'invoice' | 'order';
  id?: number;
  orderDate?: string;
  totalAmount?: string;
  status?: InventoryOrderStatus;
  invoiceDate?: string;
  createdAt?: string;
  invoiceStatus: INVOICE_STATUS;
  invoiceTotal?: number;
  invoiceUrls?: string | string[];
  vendorId?: number;
  vendorName?: string;
  vendor?: Vendor;
}

export interface IOrdersAndInvoiceResponseType {
  response: {
    success: boolean;
    data:
      | {
          ordersAndInvoices: IOrderInvoiceResponse[];
          currentPage?: number;
          nextPage?: boolean;
          pageSize?: number;
          totalPages?: number;
        }
      | [];
    message: string;
    error: string | null;
  };
  statusCode: number;
}

export interface IAllOrdersResponseType {
  response: {
    success: boolean;
    data: { orders: IOrderDataResponse[]; currentPage?: number; nextPage?: boolean } | [];
    message: string;
    error: string | null;
  };
  statusCode: number;
}

export interface IOrderByIdResponseType {
  response: {
    success: boolean;
    data: { order: IOrderDataResponse | null };
    message: string;
  };
  statusCode: number;
}

export interface ICreatedOrderResponseType {
  success: boolean;
  data: IOrderDataResponse;
  message: string;
}
export enum InventoryOrderStatus {
  PLACED = 'Placed',
  RECEIVED = 'Received',
  PENDING = 'Pending',
  CANCELED = 'Canceled',
}
